import axios from 'axios';
import { OPEN_IBAN_VALIDATION_API_URL } from './constants';
import { ValidateIbanResponse } from './types';
import * as Sentry from '@sentry/vue';

export const validateIban = async (iban: string): Promise<ValidateIbanResponse | null> => {
  if (!iban) {
    return null;
  }

  const strippedIban = iban.replace(/\s+/g, '');

  try {
    const { data } = await axios.get<ValidateIbanResponse>(
      `${OPEN_IBAN_VALIDATION_API_URL}/${encodeURIComponent(strippedIban)}`,
      {
        params: {
          getBIC: true,
        },
      }
    );

    return data;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        iban,
      },
    });

    return null;
  }
};
